module.exports = __webpack_public_path__ + "assets/location-icon-df4cce.svg";